import { gql } from '@apollo/client';

export const CREATE_EXTERNAL_POST_MUTATION = gql`
  mutation CreateExternalPost($data: createExternalPostInput!) {
    createExternalPost(input: $data) {
      externalPost {
        id
        bannerImg {
          url
          id
          formats
        }
        bannerImgUrl

        hotel {
          id
        }
      }
    }
  }
`;
